export const isValidRegex = (regex) => {
  let isValid = true;
  try {
    new RegExp(regex);
  } catch (e) {
    isValid = false;
  }
  return isValid;
};
